import ReactDOM from 'react-dom';
import React from 'react';

export default function checkoutSurveyLauncher() {
    return import(
        /* webpackChunkName: "checkoutSurvey" */
        '../../../abandonedCheckout/components/CheckoutSurvey'
    ).then(({ default: CheckoutSurvey }) => {
        const el = window.document.createElement('div');
        window.document.body.appendChild(el);
        ReactDOM.render(React.createElement(CheckoutSurvey, {}), el);
    });
}
